import React from "react";
import {
  LinkIcon,
  GoogleCalendarIcon,
  SlackIcon,
  ZoomIcon,
  TeamsIcon,
} from "./SettingsIcons";

const APPS = [
  {
    id: "google-calendar",
    name: "Google Calendar",
    desc: "Sync your calendar events and meetings",
    icon: GoogleCalendarIcon,
    connected: true,
  },
  {
    id: "slack",
    name: "Slack",
    desc: "Get notifications and updates in Slack",
    icon: SlackIcon,
    connected: false,
  },
  {
    id: "zoom",
    name: "Zoom",
    desc: "Start and join Zoom meetings directly",
    icon: ZoomIcon,
    connected: true,
  },
  {
    id: "teams",
    name: "Microsoft Teams",
    desc: "Collaborate with your team on Microsoft Teams",
    icon: TeamsIcon,
    connected: false,
  },
];

const SettingsIntegrationsTab = ({ integrations, setIntegrations }) => {
  const toggleIntegration = (id) => {
    setIntegrations((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="v2-settings-pg-card">
      <div className="v2-settings-pg-card__header">
        <div className="v2-settings-pg-card__icon-wrap" style={{ background: "#eff6ff" }}>
          <LinkIcon size={20} color="#3b82f6" />
        </div>
        <div>
          <h3 className="v2-settings-pg-card__title">Connected Apps</h3>
          <p className="v2-settings-pg-card__subtitle">
            Manage your third-party app connections
          </p>
        </div>
      </div>

      <div className="v2-settings-pg-card__body">
        <div className="v2-settings-pg-integrations-list">
          {APPS.map((app) => {
            const Icon = app.icon;
            const isConnected =
              integrations[app.id] !== undefined
                ? integrations[app.id]
                : app.connected;
            return (
              <div className="v2-settings-pg-integ-item" key={app.id}>
                <div className="v2-settings-pg-integ-item__left">
                  <div className="v2-settings-pg-integ-item__icon">
                    <Icon size={28} />
                  </div>
                  <div className="v2-settings-pg-integ-item__text">
                    <span className="v2-settings-pg-integ-item__name">{app.name}</span>
                    <span className="v2-settings-pg-integ-item__desc">{app.desc}</span>
                  </div>
                </div>
                <div className="v2-settings-pg-integ-item__right">
                  <span
                    className={`v2-settings-pg-integ-badge${isConnected ? " v2-settings-pg-integ-badge--connected" : ""}`}
                  >
                    {isConnected ? "Connected" : "Not Connected"}
                  </span>
                  <button
                    className={`v2-settings-pg-integ-btn${isConnected ? " v2-settings-pg-integ-btn--disconnect" : ""}`}
                    onClick={() => toggleIntegration(app.id)}
                  >
                    {isConnected ? "Disconnect" : "Connect"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SettingsIntegrationsTab;
